import cx from 'clsx';
import { motion } from 'motion/react';

import classes from './ChatMessage.module.css';
import type { BaseMessageProps } from './types';

type ChatMessageKind = 'error' | 'success' | 'subtle';

export function ChatMessage({
  role,
  content,
  timestamp,
  children,
  kind,
}: React.PropsWithChildren<BaseMessageProps & { kind?: ChatMessageKind }>) {
  return (
    <motion.div
      className={cx(classes.bubble, classes[role], kind && classes[`kind-${kind}`])}
      data-chat-message
      variants={containerTransition}
      initial="hidden"
      animate="show"
    >
      <div className={classes.container}>
        {children ? (
          children
        ) : (
          <>
            <div className={classes.content}>{content}</div>
            {timestamp && (
              <div className={classes.timestamp}>
                {timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
              </div>
            )}
          </>
        )}
      </div>
    </motion.div>
  );
}

const defaultDuration = 0.3;
const glintDuration = 1.5;
const fullDuration = 1.5;
const containerTransition = {
  hidden: {
    height: 0,
    '--transition': 0,
    '--color-progress': 0,
    '--turn-progress': 0.5,
    '--pos-progress': 0,
  },
  show: {
    height: 'auto',
    '--transition': 1,
    '--color-progress': [0, 0, 1, 0],
    '--turn-progress': [0.5, 0.5, 0.3],
    '--pos-progress': [0, 0, 1],
    transition: {
      default: {
        duration: defaultDuration,
      },
      '--color-progress': {
        duration: fullDuration,
        times: [0, defaultDuration / glintDuration, 0.4, 1],
        when: 'afterChildren',
      },
      '--turn-progress': {
        duration: fullDuration,
        times: [0, defaultDuration / glintDuration, 1],
        when: 'afterChildren',
      },
      '--pos-progress': {
        duration: fullDuration,
        times: [0, defaultDuration / glintDuration, 1],
        when: 'afterChildren',
      },
    },
  },
};
